import { motion } from "framer-motion";
import { Phone, Instagram, MessageCircle, MapPin } from "lucide-react";
import { PHONE_TEL, PHONE_DISPLAY, INSTAGRAM_URL, INSTAGRAM_HANDLE, waLink } from "../lib/scroll";

const CARDS = [
  {
    id: "contact-phone-number-link",
    href: PHONE_TEL,
    icon: Phone,
    label: "Call the bakery",
    value: PHONE_DISPLAY,
    note: "Sun–Sat, whenever the oven is on",
    external: false,
  },
  {
    id: "contact-whatsapp-direct-button",
    href: waLink("Hi Zoni's Bakehouse! I'd like to place an order."),
    icon: MessageCircle,
    label: "WhatsApp us",
    value: "Message your order",
    note: "Fastest way to get a box reserved",
    external: true,
  },
  {
    id: "contact-instagram-handle-link",
    href: INSTAGRAM_URL,
    icon: Instagram,
    label: "Follow the ovens",
    value: INSTAGRAM_HANDLE,
    note: "Today's bake, first on the feed",
    external: true,
  },
];

export default function Order() {
  return (
    <section id="contact" className="scroll-mt-24 bg-goldlight py-24 sm:py-36 border-y-[3px] border-ink">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl mb-14 sm:mb-20"
        >
          <p className="font-mono text-[10px] sm:text-xs uppercase tracking-[0.3em] text-rust mb-4">
            Order &amp; Contact
          </p>
          <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-7xl leading-[1.0] tracking-tight">
            Save room for us.
          </h2>
          <p className="mt-6 text-browntext leading-relaxed flex items-start gap-2 text-sm sm:text-base">
            <MapPin size={16} className="shrink-0 mt-1 text-rust" />
            Baked to order in Dadar, Mumbai. Call, WhatsApp or DM — tell us
            what you&apos;re craving and when you need it.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-5 sm:gap-7">
          {CARDS.map((c, i) => (
            <motion.a
              key={c.id}
              href={c.href}
              target={c.external ? "_blank" : undefined}
              rel={c.external ? "noopener noreferrer" : undefined}
              data-testid={c.id}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="group bg-eggshell border-[3px] border-ink rounded-[24px] p-7 sm:p-9 shadow-[8px_8px_0_#1C1512] hover:shadow-[4px_4px_0_#1C1512] hover:translate-x-[4px] hover:translate-y-[4px] transition-all duration-300"
            >
              <span className="w-12 h-12 rounded-full border-[1.5px] border-ink flex items-center justify-center mb-8 group-hover:bg-rust group-hover:text-eggshell group-hover:border-rust transition-colors duration-300">
                <c.icon size={19} strokeWidth={2} />
              </span>
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-mutedbrown mb-2">
                {c.label}
              </p>
              <p className="font-display font-bold text-xl sm:text-2xl tracking-tight group-hover:text-rust transition-colors duration-300">
                {c.value}
              </p>
              <p className="mt-3 text-sm text-browntext">{c.note}</p>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
